<template lang="pug">
  v-layout(row wrap class="page-vouchers")
    v-flex(xs12 sm12 :md4="elecVoucherIntro" :lg4="elecVoucherIntro" :md1="elecVoucherPage" :lg1="elecVoucherPage")
    v-flex(xs12 sm12 :md4="elecVoucherIntro" :lg4="elecVoucherIntro" :md10="elecVoucherPage" :lg10="elecVoucherPage" id="intro-electronic")
      .step-one(v-if="elecVoucherIntro")
        h2 Comprobantes Electrónicos
        br
        p.main-parraf(v-if="$vuetify.breakpoint.smAndDown") Para generar un comprobante electrónico se requiere de estos datos:
        p.main-parraf(v-if="$vuetify.breakpoint.mdAndUp")
          | Para generar un comprobante
          br
          | electrónico se requiere de estos datos:
        br
        v-layout(row wrap class="vouchers-indications")
          v-flex(xs12 sm1 md1 lg1)
          v-flex(xs6 sm5 md5 lg5)
            p
              strong Tipo de Documento
          v-flex.hidden-sm-and-down(sm1 md1 lg1)
          v-flex(xs6 sm4 md4 lg4)
            p
              strong Folio del Documento
          v-flex.hidden-sm-and-down(sm1 md1 lg1)
          v-flex.hidden-sm-and-down(sm1 md1 lg1)
          v-flex(xs6 sm5 md5 lg5)
            p
              strong Fecha Emisión
          v-flex.hidden-sm-and-down(sm1 md1 lg1)
          v-flex(xs6 sm4 md4 lg4)
            p
              strong Monto Total
          v-flex(xs12 sm1 md1 lg1)
        v-layout(row wrap :style="$vuetify.breakpoint.smAndUp ? 'text-align:center' : ''")
          v-flex(xs6 sm6 md5 lg5)
            v-btn(@click="goPaperless" :block="$vuetify.breakpoint.mdAndUp" class="first-ebtn") SI, LO TENGO
          v-flex.hidden-sm-and-down(md2 lg2)
          v-flex(xs6 sm6 md5 lg5)
            v-btn(class="last-ebtn" :block="$vuetify.breakpoint.mdAndUp" @click="goToElectronicVouchers") NECESITO AYUDA
      .step-two(v-else-if="elecVoucherPage")
        .form-container
          h2 Te ayudamos
          br
          p.main-parraf Completa los campos para brindarte los datos que necesitas
          v-layout(row wrap)
            v-flex(xs12 sm12 md2 lg2)
              label Producto
              v-select(:items="arrays.products" placeholder="Seleccionar producto" append-icon="keyboard_arrow_down" @change="searchVouchers" v-model="selected.numberPolicy")
            v-flex.hidden-sm-and-down.divider(md1 lg1)
            v-flex(xs12 sm12 md2 lg2)
              label Tipo de documento
              v-select(:items="arrays.typeDocuments" placeholder="Seleccionar tipo de documento" append-icon="keyboard_arrow_down" @change="changeYearByDoc" v-model="selected.typeDocument")
            v-flex.hidden-sm-and-down.divider(md1 lg1)
            v-flex(xs5 sm5 md2 lg2)
              label Año
              v-select(:items="arrays.years" placeholder="Seleccionar año" @change="changeMonthByYear" append-icon="keyboard_arrow_down" v-model="selected.year")
            v-flex.divider(xs2 sm2 md1 lg1)
            v-flex(xs5 sm5 md2 lg2)
              label Mes
              v-select(:items="arrays.months" placeholder="Seleccionar mes" @change="checkFields" append-icon="keyboard_arrow_down" v-model="selected.month")
            v-flex.hidden-sm-and-down.divider(md1 lg1)
            v-flex(xs12 sm12 md1 lg1)
              v-btn(class="last-ebtn" block @click="submitVouchers" :disabled="disabled") BUSCAR
        .form-container-result
          v-layout.step-three(row wrap v-if="elecVoucherResult && $vuetify.breakpoint.mdAndUp")
            v-layout(column class="containers second")
              h2 {{ text.monthSelected }} {{ selected.year }}
              p.paragraph.color ¡Bien! Ya tienes los datos que necesitas,
              p.paragraph ahora copia y pega los datos en el formulario de comprobante electrónico
              v-flex.result-vouchers(xs12 sm12 md12 lg12 v-for="(item, index) in vouchersFiltered" :key="index")
                v-layout(row wrap)
                  v-flex(md3 lg3)
                    p
                      strong Tipo de documento
                      br
                      | {{ item.tipoComprobante }}
                  v-flex(md3 lg3)
                    p
                      strong Folio del documento
                      br
                      | {{ item.secuencial }}
                  v-flex(md3 lg3)
                    p
                      strong Fecha de emisión
                      br
                      | {{ item.fechaEmision }}
                  v-flex(md3 lg3)
                    p
                      strong Monto total
                      br
                      | {{ item.montoTotal }}
              v-btn(@click="goPaperless" class="last-ebtn") IR AL COMPROBANTE ELECTRÓNICO
      .step-three(v-if="elecVoucherResult && $vuetify.breakpoint.smAndDown")
        v-layout(row wrap class="containers first")
          v-flex(xs12 sm12 md12 lg12)
            v-layout(row wrap)
              v-flex(xs6 sm6 md6 lg6)
                p
                  | Producto
                  br
                  strong {{ text.productSelected }}
              v-flex(xs6 sm6 md6 lg6)
                p
                  | Tipo de documento
                  br
                  strong {{ selected.typeDocument }}
            v-layout(row wrap)
              v-flex(xs6 sm6)
                p
                  | Mes
                  br
                  strong {{ text.monthSelected }}
              v-flex(xs6 sm6)
                p
                  | Año
                  br
                  strong {{ selected.year }}
            v-btn(@click="goBackSearch" class="first-ebtn") CAMBIAR BÚSQUEDA
        v-layout(column class="containers second")
          h3 {{ text.monthSelected }} {{ selected.year }}
          p.paragraph.color ¡Bien! Ya tienes los datos que necesitas,
          p.paragraph ahora copia y pega los datos en el
          p.paragraph formulario de comprobante electrónico
          v-flex.result-vouchers(xs12 sm12 md12 lg12 v-for="(item, index) in vouchers" :key="index")
            v-layout(row wrap)
              v-flex(xs6 sm6 md6 lg6)
                p
                  strong Tipo de documento
                  br
                  | {{ item.tipoComprobante }}
              v-flex(xs6 sm6 md6 lg6)
                p
                  strong Folio del documento
                  br
                  | {{ item.secuencial }}
            v-layout(row wrap)
              v-flex(xs6 sm6 md6 lg6)
                p
                  strong Fecha de emisión
                  br
                  | {{ item.fechaEmision }}
              v-flex(xs6 sm6 md6 lg6)
                p
                  strong Monto total
                  br
                  | {{ item.montoTotal }}
          v-btn(@click="goPaperless" class="last-ebtn") IR AL COMPROBANTE ELECTRÓNICO
    v-flex(xs12 sm12 :md4="elecVoucherIntro" :lg4="elecVoucherIntro" :md1="elecVoucherPage" :lg1="elecVoucherPage")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'

export default {
  data () {
    return {
      arrays: {
        products: [],
        typeDocuments: [],
        years: [],
        months: []
      },
      selected: {
        numberPolicy: null,
        typeDocument: null,
        year: null,
        month: null
      },
      text: {
        productSelected: '',
        monthSelected: ''
      },
      vouchers: [],
      disabled: true,
      elecVoucherIntro: true,
      elecVoucherPage: false,
      elecVoucherResult: false
    }
  },
  computed: {
    ...mapGetters('user', ['polizasInfo', 'userInfo'])
  },
  methods: {
    ...mapActions('user', ['getElectronicDocuments', 'getPolizas']),
    goPaperless () {
      window.open('https://asp403r.paperless.com.pe/FacturaInterseguro/', '_blank')
    },
    goToElectronicVouchers () {
      this.elecVoucherIntro = false
      this.elecVoucherPage = true
      document.querySelectorAll('.page-vouchers')[0].classList.add('in-form')
    },
    goBackSearch () {
      this.elecVoucherResult = false
      this.elecVoucherPage = true
      this.elecVoucherIntro = false
    },
    searchVouchers () {
      let item = { numeroPoliza: this.selected.numberPolicy }
      this.selected.typeDocument = null
      this.selected.year = null
      this.selected.month = null
      this.elecVoucherResult = false
      /** MAKE REQUEST */
      this.getElectronicDocuments(item)
        .then((res) => {
          if (res.data.documentosElectronicos.length > 0) {
            this.vouchers = res.data.documentosElectronicos
            let arrVouchers = this.vouchers.map(f => { return f.tipoComprobante })
            let arrTypeDocs = arrVouchers.filter(function (item, index) { return arrVouchers.indexOf(item) >= index })
            for (let index = 0; index < arrTypeDocs.length; index++) {
              switch (arrTypeDocs[index]) {
              case 'FAC':
                this.arrays.typeDocuments.push({text: 'Factura', value: 'FAC'})
                break
              case 'N/C':
                this.arrays.typeDocuments.push({text: 'Nota Crédito', value: 'N/C'})
                break
              case 'B/V':
                this.arrays.typeDocuments.push({text: 'Boleta', value: 'B/V'})
                break
              }
            }
            /** GET PRODUCT OF LIST */
            let productSelected = this.arrays.products.filter(f => {
              return f.value === item.numeroPoliza
            })
            /** SET TEXT FOR SHOW IN RESUMEN */
            this.text.productSelected = productSelected[0].text
          } else {
            this.$swal({
              title: 'Atención',
              text: 'No tienes documentos electrónicos por consultar para este producto.',
              type: 'warning',
              confirmButtonText: 'Entendido'
            })
          }
        })
        .catch(() => {
          this.$swal({
            title: 'Atención',
            text: 'Tenemos inconvenientes en obtener los datos de este producto. Por favor, vuelva a intentarlo en 5 minutos.',
            type: 'warning',
            confirmButtonText: 'Entendido'
          })
        })
    },
    changeYearByDoc () {
      let typeDocSelected = this.selected.typeDocument
      this.arrays.months = []
      this.arrays.years = []
      let dateEmited = this.vouchers
        .filter(f => { return f.tipoComprobante === typeDocSelected })
        .map(f => { return f.fechaEmision })
      dateEmited.forEach(el => {
        let dateDoc = el.split(' ')[0]
        let arrDateDoc = dateDoc.split('/')
        this.arrays.years.push(arrDateDoc[2])
      })
    },
    changeMonthByYear () {
      let self = this
      this.arrays.months = []
      let vouchers = this.vouchers
        .filter(v => {
          let voucherDate = v.fechaEmision.split(' ')
          let selectedDate = moment('01/01/' + self.selected.year, 'DD/MM/YYYY')
          let selectedEndOfTheDate = moment('31/12/' + self.selected.year, 'DD/MM/YYYY')
          voucherDate = moment(voucherDate[0], 'DD/MM/YYYY')
          return v.tipoComprobante === self.selected.typeDocument && voucherDate.isBetween(selectedDate, selectedEndOfTheDate)
        })
        .map(f => { return f.fechaEmision })
      vouchers.forEach(el => {
        let dateDoc = el.split(' ')[0]
        let arrDateDoc = dateDoc.split('/')
        this.arrays.months.push(arrDateDoc[1])
      })
      this.arrays.months.sort()
      this.arrays.months = this.arrays.months.map(r => {
        let months = moment().locale('es')
        return {'value': r, 'text': (months.month(r - 1).format('MMMM')).charAt(0).toUpperCase() + (months.month(r - 1).format('MMMM')).slice(1)}
      })
    },
    submitVouchers () {
      let months = moment().locale('es')
      let self = this
      this.text.monthSelected = (months.month(this.selected.month - 1).format('MMMM')).charAt(0).toUpperCase() + (months.month(this.selected.month - 1).format('MMMM')).slice(1)
      this.vouchersFiltered = this.vouchers.filter((v, i) => {
        let voucherDate = v.fechaEmision.split(' ')
        let selectedDate = moment('01/' + ('0' + self.selected.month).slice(-2) + '/' + self.selected.year, 'DD/MM/YYYY')
        let selectedEndOfTheDate = moment(selectedDate).endOf('month')
        voucherDate = moment(voucherDate[0], 'DD/MM/YYYY')
        return v.tipoComprobante === self.selected.typeDocument && voucherDate.isBetween(selectedDate, selectedEndOfTheDate)
      })
      // - REMOVE DUPLICATE ELEMENTS IN ARRAY
      var obj = {}
      for (var i = 0, len = this.vouchersFiltered.length; i < len; i++) {
        obj[this.vouchersFiltered[i]['fechaEmision']] = this.vouchersFiltered[i]
      }
      this.vouchersFiltered = []
      for (var key in obj) { this.vouchersFiltered.push(obj[key]) }
      // - REMOVE DUPLICATE ELEMENTS IN ARRAY
      if (this.vouchersFiltered.length > 0) {
        this.elecVoucherResult = true
        this.elecVoucherPage = false
        this.elecVoucherIntro = false
        // CONTROL VISION FOR DESKTOP!
        if (this.$vuetify.breakpoint.mdAndUp) {
          this.elecVoucherResult = true
          this.elecVoucherPage = true
          this.elecVoucherIntro = false
        }
      } else {
        this.$swal({
          title: 'Atención',
          text: 'No tienes documentos electrónicos por consultar en la fecha seleccionada.',
          type: 'warning',
          confirmButtonText: 'Entendido'
        })
      }
    },
    checkFields () {
      if (this.selected.numberPolicy && this.selected.typeDocument && this.selected.year && this.selected.month) {
        this.disabled = false
      } else {
        this.disabled = true
      }
    }
  },
  mounted () {
    /** IF ENTER TO THIS PAGE AT THE FIRST TIME */
    let self = this
    this.$root.$on('donePolizas', function (obj) {
      self.arrays.products = self.polizasInfo.map(function (pol) {
        if (pol.ramo === 'RRVV' || pol.ramo === 'Vida' || (pol.ramo === 'Masivo' && pol.producto === 'SOAT' && pol.placa !== null) || (pol.ramo === 'Masivo' && pol.producto !== 'SOAT')) {
          return { 'text': pol.producto + ' - ' + pol.numeroPoliza, 'value': pol.numeroPoliza }
        }
      }).filter(function (el) { return el !== undefined })
    })
    /** IF BACK TO OTHER PAGE, THEN RETURN HERE */
    if (this.polizasInfo && this.polizasInfo.length > 0) {
      this.arrays.products = this.polizasInfo.map(function (pol) {
        if (pol.ramo === 'RRVV' || pol.ramo === 'Vida' || (pol.ramo === 'Masivo' && pol.producto === 'SOAT' && pol.placa !== null) || (pol.ramo === 'Masivo' && pol.producto !== 'SOAT')) {
          return { 'text': pol.producto + ' - ' + pol.numeroPoliza, 'value': pol.numeroPoliza }
        }
      }).filter(function (el) { return el !== undefined })
    }
    /** EMIT EVENT FOR DISABLE HOME ICONS */
    if (this.$vuetify.breakpoint.smAndDown) {
      this.$root.$emit('disableAllIcons', {})
    }
  }
}
</script>

<style>
  .page-vouchers {
    background-color: #F6F6F6;
  }
  #intro-electronic p.main-parraf, #intro-electronic h2 { text-align: center; }
  #intro-electronic .first-ebtn {
    border-radius: 5px;
    background-color: rgb(8, 85, 196);
    border-color: rgb(8, 85, 196);
  }
  #intro-electronic .last-ebtn {
    border-radius: 5px;
    background-color: rgb(234,12,144);
    border-color: rgb(234,12,144);
  }
  #intro-electronic .v-btn {
    margin-right: 0;
    margin-left: 0;
  }
  #intro-electronic .v-btn .v-btn__content { color: #FFF; }
  #intro-electronic .step-one, #intro-electronic .step-two {
    margin-top: 8%;
    background-color: #FFF;
    padding: 20px 15px;
  }
  #intro-electronic .step-three .layout.containers.first {
    background-color: #FFF;
    margin-top: 3em;
    padding: 24px 0 20px 31px;
  }
  #intro-electronic .step-three .layout.containers.second {
    margin-top: 3em;
    background-color: #FFF;
    padding: 26px 24px 18px 13px;
    margin-bottom: 1em;
  }
  /** STEP THREE */
  #intro-electronic .step-three .layout.containers .paragraph.color {
    color: rgb(8, 85, 196);
  }
  #intro-electronic .step-three .layout.containers .paragraph, .step-three .layout.containers h3 { text-align: center; }
  #intro-electronic .step-three .layout.containers .result-vouchers {
    margin-top: 2em;
    border: #7C7C7C 1px solid;
    border-radius: 6px;
    padding: 18px 0 0 27px;
  }
  #intro-electronic .step-three .layout.containers .paragraph { margin-bottom: 0; }
  #intro-electronic .step-two .v-text-field .v-input__append-inner .v-input__icon i {
    color: #0855C4 !important;
    caret-color: #0855C4 !important;
  }
  /* Small to large handset ----------- */
@media only screen and (max-width : 600px) {
  .page-vouchers {
    background-color: transparent;
  }
  #intro-electronic .step-one, #intro-electronic .step-two {
    margin-top: 0;
    padding: 0;
  }
  #intro-electronic h2 {
    line-height: 1.2;
    font-size: 25px;
  }
  #intro-electronic p.main-parraf {
    margin-bottom: 3px;
    font-size: 15px;
  }
  #intro-electronic .step-three .layout.containers.first {
    padding: 0;
    margin: 0;
  }
  #intro-electronic .step-three .layout.containers.second {
    margin-top: 1em;
    margin-bottom: 0;
    padding: 0;
  }
  #intro-electronic .step-three .layout.containers .result-vouchers {
    padding: 15px 0 0 14px;
  }
  #intro-electronic .step-three .layout.containers.second .last-ebtn {
    margin-top: 1em;
  }
}
/* Desktop ----------- */
@media only screen  and (min-width : 1265px) {
  .page-vouchers {
    background-color: #FFF;
  }
  .vouchers-indications {
    padding-top: 1.5em;
    border: 2px solid #F6F6F6;
    margin-bottom: 2em;
  }
  .page-vouchers.in-form {
    background-color: #F6F6F6;
  }
  #intro-electronic .step-one { margin-top: 15%; }
  #intro-electronic h2 { font-size: 24px; }
  #intro-electronic p.main-parraf { font-size: 15px; }
  #intro-electronic .step-two { padding: 0; }
  #intro-electronic .step-two .divider {
    flex-basis: 5.8%;
    flex-grow: 0;
    max-width: 5.8%;
  }
  #intro-electronic .v-btn {
    margin-bottom: 0;
    margin-top: 20px;
  }
  #intro-electronic .step-two .form-container .layout { margin-top: 3em; }
  #intro-electronic .step-two .layout label { font-family: 'Omnes Medium'; }
  #intro-electronic .step-two .layout .v-text-field { padding: 0 }
  #intro-electronic .step-three .layout.containers.second {
    padding: 0;
    margin-top: 0;
  }
  /** FOR STEP TWO IN DESKTOP */
  #intro-electronic .step-two {
    background-color: #F6F6F6;
    margin-top: 6%;
  }
  #intro-electronic .step-two .form-container-result { margin-top: 3em; }
  #intro-electronic .form-container {
    padding: 20px 14px 14px 14px;
    background-color: #FFF;
    border-radius: 13px;
  }
  #intro-electronic .form-container-result .step-three .layout.containers.second  {
    padding: 20px 14px 14px 20px;
    border-radius: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ElectronicVouchers.vue